import React, { useEffect } from "react";
import "../style/style.css";
import { useLocation, useNavigate } from "react-router-dom";
import AuthFaceScanPage from "../Components/AuthFaceScanPage";
import { observer } from "mobx-react-lite";
import DataUserLoyalty from "../store/DataUserLoyalty";

const Auth = observer(() => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const placeId = params.get("place_id");
  console.log(placeId);
  DataUserLoyalty.placeId = placeId;
  const navigate = useNavigate();

  useEffect(() => {
    if (!!localStorage.getItem("user")) {
      navigate(
        `/userLoyalty/main${
          DataUserLoyalty.placeId ? `?place_id=${DataUserLoyalty.placeId}` : ""
        }`
      );
    }
  }, [navigate]);

  return (
    <div className='container centerItem'>
      <AuthFaceScanPage />
    </div>
  );
});

export default Auth;
